import styled from "styled-components";

const TruncateStyled = styled.p`
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  margin: 0;
`;

export default TruncateStyled;
